// extracted by mini-css-extract-plugin
export default {"expandedNotification":"tasks-async-operation-status_expandedNotification__9ZWIx"};